import spinner from 'assets/images/css-loading-white.png';

import { FC } from 'react';

import { useTranslate } from 'hooks/useTranslate';

import './CustomContainedLoading.scss';

const CustomContainedLoading: FC = () => {
  const { t } = useTranslate();

  return (
    <div className="custom-loading-spinner loading-contained">
      <div className="loading-contained__wrapper d-flex justify-content-center align-items-center">
        <div className="loading-pulse-sm">
          <img src={spinner} alt={t('Loading')} />
        </div>
      </div>
    </div>
  );
};

export default CustomContainedLoading;
